import {AfterContentInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {ExternalEmployeeService} from '../../../services/external-employee.service';
import {AppSettingsService} from '../../../services/app-settings.service';
import {FormBuilder, Validators} from '@angular/forms';
import {StaticMethods} from '../../../model/GeneralModels';

@Component({
  selector: 'app-request-details',
  templateUrl: './request-details.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ],
  styles: [`
    .mat-form-field + .mat-form-field {
      margin-left: 8px;
    }

    .mat-accordion {
      margin-top: 10px;
    }

    .ACCEPT {
      background-color: #bae4ba;
    }

    .REJECT {
      background-color: #e4baba;
    }

    .mat-expansion-panel-header.mat-expanded .TEST ,
    .mat-expansion-panel-header .TEST {
      background-color: #e4baba !important;
    }
  `]
})
export class RequestDetailsComponent implements OnInit, AfterContentInit {
  newReplyPanelStatus: boolean;
  productName: string;
  id: number;
  status: string;
  responseStage = 'FILE';
  translation: any = {};
  requestFileType: string;
  data: {
    insuranceInfo: {
      insuranceNumber: string,
      productName: string,
      companyName: string,
      panelOpenState: boolean
    },
    personalInfo: {
      firstName: string,
      lastName: string,
      relation: string,
      panelOpenState: boolean
    },
    requestInfo: {
      stateName: string,
      cityName: string,
      fileType: string,
      dateOfSubmission: string,
    }
    replies: {
      dateOfPayment: number;
      acceptedAmount: number;
      missingDocument: string;
      responseID: number,
      employeeName: string,
      reply: string,
      comment: string,
      dateOfReply: string,
      timeOfReply: string,
      requestedFileType: string,
      responseStage: string,
      userReply: {
        fileUrl: string,
        dateOfUserReply: string,
        timeOfUserReply: string
      },
      panelOpenState: boolean
    }[],
    status: string,
  };
  upload = false;
  damageAmount: number;

  constructor(private activateRoute: ActivatedRoute,
              private service: ExternalEmployeeService,
              public settings: AppSettingsService,
              private fb: FormBuilder, private router: Router) {
  }

  ngOnInit() {
  }

  ngAfterContentInit(): void {
    this.activateRoute.params.subscribe((params: Params) => {
      this.productName = params.productName;
      this.id = params.id;
      this.getData();
    });
  }

  getData() {
    this.service.getRequestDetails(this.productName, this.id).subscribe(response => {
      if (response.success) {
        this.status = response.data.status;
        this.damageAmount = response.data.requestInfo.damageAmount;
        console.log('status: ', this.status);
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        this.requestFileType = response.data.requestInfo.fileType;
        this.data = response.data;
        if (this.data.replies.length) {
          this.responseStage = this.data.replies[this.data.replies.length - 1].responseStage;
        }
      }
    });
  }

  downloadRequestFile() {
    this.service.downloadFile(this.id, this.requestFileType, this.productName);
  }

  downloadRequestedFile(replyID) {
    this.service.downloadFile(replyID, 'RequestedFile', this.productName);
  }
}
